// Apollo client for Pimcore public-content entry point
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { getGraphqlEndpoint } from '../../../utils/Pimcore';

const httpLink = new HttpLink({
    uri: getGraphqlEndpoint({ direct: true, cached: false }),
    // fetch: fetch, // 需要的話可顯式指定；Next/Node 18+ 已內建
});

const pimcoreClient = new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
    ssrMode: typeof window === 'undefined',
    defaultOptions: {
        watchQuery: { fetchPolicy: 'no-cache' },
        query: { fetchPolicy: 'no-cache' },
    },
});

export default pimcoreClient;
